import { fmtDate } from "@/lib/api";

const LABELS = {
  "record.created": "Record created", "record.updated": "Record edited", "record.assigned": "Assigned",
  "record.submitted": "Submitted for approval", "record.review_started": "Review started", "record.approved": "Approved",
  "record.rejected": "Rejected", "record.returned": "Returned for correction", "record.archived": "Archived",
  "record.reopened": "Reopened", "record.hard_deleted": "Permanently deleted", "attachment.added": "Attachment added",
  "attachment.replaced": "Attachment replaced (new version)", "attachment.removed": "Attachment removed",
  "attachment.downloaded": "Attachment downloaded", "record.certificate_printed": "Approval cover sheet generated",
};
const DOT = { "record.approved": "bg-emerald-500", "record.rejected": "bg-rose-500", "record.returned": "bg-amber-500",
  "record.hard_deleted": "bg-rose-700", "record.archived": "bg-purple-500", "record.reopened": "bg-sky-500" };

export const actionLabel = (a) => LABELS[a] || a.replace(/[._]/g, " ");

export const detailText = (d = {}) =>
  Object.entries(d).filter(([, v]) => v !== null && v !== "" && !(Array.isArray(v) && !v.length))
    .map(([k, v]) => `${k.replace(/_/g, " ")}: ${Array.isArray(v) ? v.join(", ") : typeof v === "object" ? JSON.stringify(v) : v}`).join(" · ");

export const TimelinePanel = ({ items }) => (
  <div className="rounded-lg border border-slate-200 bg-white shadow-sm" data-testid="audit-timeline-container">
    <div className="px-4 py-3 border-b border-slate-200 font-display font-semibold text-sm">Timeline & audit trail</div>
    <ol className="p-4 max-h-[640px] overflow-y-auto">
      {items.map((e, i) => (
        <li key={e.log_id} className="relative pl-6 pb-5 last:pb-0" data-testid={`timeline-entry-${e.seq}`}>
          {i < items.length - 1 && <span className="absolute left-[5px] top-3 bottom-0 w-px bg-slate-200" />}
          <span className={`absolute left-0 top-1.5 w-[11px] h-[11px] rounded-full ring-4 ring-white ${DOT[e.action] || "bg-slate-400"}`} />
          <div className="text-sm font-medium text-slate-800">{actionLabel(e.action)}</div>
          <div className="text-[11px] text-slate-500">{e.actor_name} · <span className="uppercase tracking-wider">{e.actor_role?.replace("_", " ")}</span> · {fmtDate(e.at)}</div>
          {detailText(e.details) && <div className="text-xs text-slate-600 mt-1 break-words">{detailText(e.details)}</div>}
        </li>
      ))}
      {items.length === 0 && <li className="text-sm text-slate-500">No activity yet.</li>}
    </ol>
  </div>
);
